import React from 'react';
import classnames from 'clsx';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { NumberInput } from 'ui-components/components/number-input';
import { RadioCheckList } from 'ui-components/components/radio-check-list';
import { RadioCheckListItem } from 'ui-components/components/radio-check-list/radio-check-list-item';
import { Text } from 'ui-components/components/text';
import { TextType } from 'ui-components/components/text/text-type';

import style from './auto-split-radio-buttons-style.module.css';
import { messages } from './messages';
import {
  DoNotAutoSplit,
  SplitOnLineItem,
  SplitOnQuantity,
  SplitOnCustomQty,
  MinimumSplitOnCustomQty,
} from '../constants/auto-split-options';

const autoSplitOptions = [
  {
    id: DoNotAutoSplit,
    message: messages.autoSplitDefaultOption,
  },
  {
    id: SplitOnLineItem,
    message: messages.autoSplitShipProductSeparatelyOption,
    subText: messages.autoSplitShipProductSeparatelyOptionSubText,
  },
  {
    id: SplitOnQuantity,
    message: messages.autoSplitShipProductIndividuallyOption,
    subText: messages.autoSplitShipProductIndividuallyOptionSubText,
  },
  {
    id: SplitOnCustomQty,
    message: messages.autoSplitShipProductByCustomQtyOption,
    subText: messages.autoSplitShipProductByCustomQtyOptionSubText,
  },
];

export const AutoSplitRadioButtons = ({
  selectedSplitOption = 'DoNotAutoSplit',
  disabled = false,
  onChange,
  className = '',
  currentQuantity = 0,
  setAutoSplitCustomQty,
}) => {
  return (
    <RadioCheckList className={classnames(style['auto-split-settings-container'], className)}>
      {autoSplitOptions.map((opt) => (
        <div key={opt.id} className={style['auto-split-settings-option']}>
          <RadioCheckListItem
            className={style['auto-split-settings-radio-button']}
            id={opt.id}
            isChecked={opt.id === selectedSplitOption}
            isDisabled={disabled}
            onChecked={() => onChange(opt.id)}
          >
            <FormattedMessage {...opt.message} />
          </RadioCheckListItem>
          {opt.subText ? (
            <div className={classnames(style['auto-split-settings-sub-text'])}>
              <FormattedMessage {...opt.subText} />
            </div>
          ) : null}
          {opt.id === SplitOnCustomQty && (
            <NumberInput
              className={classnames(style['ship-by-quantity-input'])}
              disabled={selectedSplitOption !== SplitOnCustomQty}
              min={MinimumSplitOnCustomQty}
              onChange={setAutoSplitCustomQty}
              value={currentQuantity}
            />
          )}
          {opt.id === SplitOnCustomQty && selectedSplitOption === SplitOnCustomQty && currentQuantity <= 0 && (
            <Text
              className={style['auto-split-error']}
              textType={TextType.Caption}
              value={messages.autoSplitShipProductByCustomQtyMustBeGreaterThanZero}
            />
          )}
        </div>
      ))}
    </RadioCheckList>
  );
};

AutoSplitRadioButtons.propTypes = {
  selectedSplitOption: PropTypes.oneOf([DoNotAutoSplit, SplitOnLineItem, SplitOnQuantity, SplitOnCustomQty]),
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  currentQuantity: PropTypes.number,
  setAutoSplitCustomQty: PropTypes.func.isRequired,
};
